import Login from ".";

export const LoginRoutes = (data) => [
  {
    path: "/login",
    title: "login",
    layout: "auth",
    routeType: "auth",
    component: Login,
  },
];
